export default __webpack_public_path__ + "static/media/brandorodriguez.9325ef91.webp";